import { type AxiosInstance, type Method } from "axios";

import { consoleErrorWithSentry } from "../../../utils";

export type NotifyVia = {
  email: boolean;
  slack: boolean;
  msTeams: boolean;
};

async function doWidgetRequest(
  api: AxiosInstance,
  method: Method,
  customerId: string,
  reportId: string,
  params?: Record<string, any>,
  notifyVia?: NotifyVia
): Promise<any> {
  try {
    if (!customerId || !reportId) {
      return;
    }

    return await api.request({
      method,
      url: `/v1/customers/${customerId}/analytics/reports/${reportId}/widget`,
      params,
      data: {
        customerId,
        reportId,
        notifyVia,
      },
    });
  } catch (error) {
    consoleErrorWithSentry(error);
    return error;
  }
}

// Refreshes the widget report data
export async function refreshCachedReport(
  api: AxiosInstance,
  customerId: string,
  reportId: string,
  notifyVia?: NotifyVia
) {
  return doWidgetRequest(api, "POST", customerId, reportId, { cachedReport: true }, notifyVia);
}

// Refreshes the widget report data
export async function refreshWidget(api: AxiosInstance, customerId: string, reportId: string) {
  return doWidgetRequest(api, "POST", customerId, reportId);
}

// Updates the widget report name and description
export async function updateWidget(api: AxiosInstance, customerId: string, reportId: string) {
  return doWidgetRequest(api, "PATCH", customerId, reportId);
}

// Deletes the report widget data
export const deleteWidget = async (api: AxiosInstance, customerId: string, reportId: string) =>
  doWidgetRequest(api, "DELETE", customerId, reportId);
